import { BaseResponseMapper } from './Base'
import { Pagination } from '@/domain/entities/Pagination'
import {
  GuideCategory,
  GuideCategoryData,
} from '@/domain/entities/GuideCategory'
import { AxiosResponse } from 'axios'

export class GuideCategoryDataMapper extends BaseResponseMapper {
  public convertFromApi(result: AxiosResponse<any>): GuideCategory {
    const { data } = result
    return new GuideCategory(
      data.success,
      data.message,
      new Pagination(
        data.pagination.current_page,
        data.pagination.page_count,
        data.pagination.page_size,
        data.pagination.row_count,
        data.pagination.first_row_on_page,
        data.pagination.last_row_on_page
      ),
      data.data.map(
        (val) =>
          new GuideCategoryData(
            val.id,
            val.name,
            val.tag,
            val.total_sop_files,
            val.sop_active,
            val.image_thumbnail,
            val.image_cover,
            val.image_logo,
            val.created_at,
            val.updated_at
          )
      )
    )
  }
}
